<template>
    <div class="dashboard-component" id="failed">
        <div class="banner failed-banner">
            <container>
                <header>
                    <div class="inner">
                        <grid horizontal="left">
                            <grid-item size="2/12" class="pointer logo-opacity">
                                <a href="/">
                                    <img class="v-middle" src="../assets/images/v-lite-white-logo.svg"><span class="logo-text">vLite</span>
                                </a>
                            </grid-item>

                            <grid-item size="10/12" class="nav-items">
                                <ul class="top-menu">
                                    <li><a href="#" @click="navigateToHomeWithDiv('howitwork')">HOW IT WORKS</a></li>
                                    <li><a href="#" @click="navigateToHomeWithDiv('features')">FEATURES</a></li>
                                    <li><a href="#" @click="navigateToHomeWithDiv('plans')">PLANS</a></li>
                                    <li><a href="#" v-scroll-to="'#plans'">BLOG</a></li>
                                    <li><a href="#" @click="openNewTab()">SIGNIN</a></li>
                                </ul>
                            </grid-item>


                        </grid>
                    </div>
                </header>
                <div class="banner-content">
                    <h1 class="white-text">Oops!</h1>
                    <h2 class="white-text">Your Signup failed.</h2>
                    <grid horizontal="left" class="vl-rltv">
                        <grid-item size="8/12" class="zindex101">
                            <h3 class="banner-text-normal white-text">Your payment did not go through</h3>
                            <h4 class="banner-text-normal white-text">{{reason}}</h4>
                            <button class="btn banner-get-btn-failed" type="button" @click="retryPaymentData()">RETRY PAYMENT</button>
                        </grid-item>
                        <grid-item  size="4/12" class="v-middle right zindex101 vl-bnr-top-ico">
                            <img class="v-middle right width60" src="../assets/images/gfx-bot.svg">

                        </grid-item>
                    </grid>

                </div>
            </container>
        </div>

        <div class="failed-basic">
            <container >
                <p class="center failed-p">{{reason}}</p>
                <p class="center failed-p">If you’re seeing this more than once, please mail us.</p>
                <div class="clearfix"></div>
            </container>
        </div>

        <div class="failed-back-color blk-pad">
            <container >
                <p class="center failed-help m-0">Need Help?</p>
                <p class="center failed-p m-0 p-top-10">Please contact us at <strong>vlitesupport@mobiotics.com</strong></p>
                <div class="clearfix"></div>
            </container>
        </div>

        <!--Footer-->
        <footer class="page-footer">
            <div class="footer-color">
                <container>
                    <grid>
                        <grid-item size="4/12">
                            <div class="vl-foot-left">
                                <div class=" logo-opacity">
                                    <!-- <img class="v-middle" src="../assets/images/v-lite-white-logo.svg"><span class="logo-text">vLite</span> -->
                                    <a href="/"><img class="v-middle" src="../assets/images/logo_white.svg" style="width:20%;"></a>
                                </div>
                            <p class="foot-copy">&copy; Copyright <label id="copyrightyear"></label><a href="https://www.mobiotics.com" target="_blank">
                                <img class="v-middle foot-cmp-logo" src="../assets/images/mobiotics-logo-horizontal.svg"></a></p>

                            </div>
                        </grid-item>
                        <grid-item size="4/12">
                            <div class="vl-foot-mid">
                                <ul>
                                    <li><a @click="openSocialNewTab('https://www.facebook.com/mobiotics')"><icon scale="1.2" class="white-text" name="facebook"></icon></a></li>
                                    <li><a @click="openSocialNewTab('https://plus.google.com/106588943035549674608/posts')"><icon scale="1.5" class="white-text" name="google-plus"></icon></a></li>
                                    <li><a @click="openSocialNewTab('https://twitter.com/mobiotics')"><icon scale="1.2" class="white-text" name="twitter"></icon></a></li>
                                </ul>
                            </div>
                        </grid-item>
                        <grid-item size="4/12">
                            <div class="vl-foot-right f-right">
                            <p class="foot-copy"><a href="#">Terms Of Use</a></p>
                            <p class="foot-copy"><a href="#">Privacy Policy</a></p>
                            </div>
                            <!-- <div class="vl-foot-right">
                                <ul>
                                    <li><a href="#">Terms of use</a></li>
                                    <li><a href="#">Privacy Policy</a></li>
                                </ul>
                            </div> -->
                        </grid-item>
                    </grid>
                </container>
            </div>
        </footer>
        <!-- basic -->

    </div>



</template>

<script>
    const { Config } = require('../assets/js/config.js');

    export default{
        data(){
            return{
                email: 'quizzertv@gmail.com',
                reason:'',
                userdata:{},
                planData:{},
                apibaseurl:'',
                vendorportalurl:''

            };
        },
        created () {
            this.email = this.$route.params.email;
            this.reason = this.$route.params.reason;
            this.userdata = this.$route.params.userdata;
        },
        mounted() {
                // Setting Config URLs
                var con = new Config()
                this.apibaseurl = con.getApiUrl();
                this.vendorportalurl = con.getPortalUrl();
                this.$scrollTo('#failed');

                var thisYear  = new Date().getFullYear();
                console.log(document.getElementById('copyrightyear'));
                document.getElementById('copyrightyear').innerHTML = thisYear;
        },
        methods: {
            openSocialNewTab(surl){
                window.open(surl, '_blank');
            },
            navigateToHomeWithDiv(divname){
                this.$router.push({ name: 'Home', params: { divid: divname}});
            },
            openNewTab() {
                window.open(this.vendorportalurl, '_blank');
            },
            navigateToHomeWithDiv(divname){
                this.$router.push({ name: 'Home', params: { divid: divname}});
            },
            retryPaymentData(){
                // GTM Code starts
                    // Subscription
                    if (localStorage.getItem("planobj") === null) {
                      this.navigateToHomeWithDiv('plans');
                  }else{
                      // Retrieve the object from storage
                      var planObject = localStorage.getItem('planobj');
                      this.planData = JSON.parse(planObject);
                  }
                     window.dataLayer = window.dataLayer || [];
                     window.dataLayer.push({
                         'event':'VLITE_PAYMENT',
                         'EventCategory': 'VLITE_PAYMENT',
                         'EventAction': 'PaymentRetry',
                         'EventLabel': 'PAYMENT_RETRY',
                         'EventValue': 1,
                         'Name': this.userdata.vendorname,
                         'Email': this.userdata.vendoremail,
                         'Contact': this.userdata.phone,
                         'Mode': this.userdata.mode,
                         'Plan': this.planData.planname,//fetch data from localstorage
                         'PlanPeriod': this.renewperiod,//fetch data from localstorage
                         'Amount': 599,//fetch data from localstorage
                         'Status': 'Retry'
                     });
                // End of GTM Code
                this.$router.push({ name: 'Dashboard', params: { userdata:this.userdata }});
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Failed.vue